




























import { Component, Vue } from "vue-property-decorator";
@Component({ name: "photon-error-component" })
export default class PhotonErrorComponent extends Vue {
  get active(): boolean {
    return this.$store.getters["SystemStore/getShowPhotonErrorModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setShowPhotonErrorModalAction", e);
  }
  showNetworkRequirements(): void {
    this.$router.push("/network-requirements").catch(() => {});
    this.active = false;
  }
}
